import React from "react";
import { connect } from "react-redux";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import VimeoIframe from "./VimeoIframe/VimeoIframe";
import ProjectInfo from "./ProjectInfo/ProjectInfo";
import Footer from "../Footer/Footer";
import "./project-page.css";

export class ProjectPage extends React.Component {
  render() {
    return (
      <div className="project-container">
        <SectionHeading
          title={this.props.project.title}
          subtitle={this.props.project.subtitle}
        />
        <VimeoIframe {...this.props.project} />
        <SectionHeading title="Project Info" />
        <ProjectInfo {...this.props.project} />
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  project: state.projects.find(
    project => project.slug === props.match.params.slug
  )
});

export default connect(mapStateToProps)(ProjectPage);



// WEBPACK FOOTER //
// ./src/components/ProjectPage/ProjectPage.js